import endpoints from 'config/endpoints';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';

import { TIMESTAMP_MULTIPLY, TIMEOUT_STORE } from 'util/constants';

module.exports = {
    createFetchParams: (filters, period, pagination, sortBy) => ({
        ...filters,
        ...period,
        ...pagination,
        ordering: sortBy
    }),
    ...storeModuleFactory({
        name:          'reportBackups',
        endpoint:      endpoints.reportBackups.endpoint,
        timeout:       TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        sortParamsMap: {
            startDate:   'start_date',
            gb:          'backup_size',
            status:      'status',
            articleName: 'item'
        },
        filterParamsMap: {
            startDate: 'start_date',
            endDate:   'end_date'
        },
        parseParameters: filters =>
            Object.keys(filters).reduce(
                (ret, key) => ({
                    ...ret,
                    [key]:
            key === 'startDate' || key === 'endDate'
                ? filters[key]
                    ? Math.floor(filters[key] / TIMESTAMP_MULTIPLY)
                    : ''
                : filters[key]
                }),
                {}
            ),
        transformEntitiesFn: item => ({
            startDate:   item.start_date * TIMESTAMP_MULTIPLY,
            endDate:     item.end_date * TIMESTAMP_MULTIPLY,
            duration:    item.duration,
            gb:          item.backup_size,
            articleName: item.item,
            host:        item.host,
            status:      item.status,
            type:        item.type,
            id_job:      item.job_id,
            agent:       item.agent
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/reportBackups.js